import {
  Box,
  Container,
  DesktopOnly,
  MobileOnly,
  Text,
  Unstable_Grid as Grid,
  useTheme,
} from '@layerzerolabs/ui-kit';
import Link from 'next/link';
import {Prism as SyntaxHighlighter} from 'react-syntax-highlighter';
import {vscDarkPlus} from 'react-syntax-highlighter/dist/cjs/styles/prism';
import {AptosBridge} from './AptosBridge';

const scriptIncludeSnippet = `
<script
  src="https://unpkg.com/@layerzerolabs/aptos-bridge-widget@
latest/element.js"
  defer
  integrity="sha384-\${checksum}"
  async
></script>
<link
  rel="stylesheet"
  href="https://unpkg.com/@layerzerolabs/aptos-bridge-widget@
latest/element.css"
/>
`;
export const WidgetPage = () => {
  const theme = useTheme();

  return (
    <Container sx={{paddingTop: '60px'}}>
      <Grid container spacing={10}>
        <Grid>
          <Text
            variant='h2'
            sx={{fontSize: {xs: '24px', sm: '36px'}, lineHeight: '96%', letterSpacing: '-1px'}}
          >
            Integrate Aptos now
          </Text>
          <Text
            variant='p2'
            sx={{mt: 3, maxWidth: '546px', display: 'block'}}
            color='text.secondary'
          >
            Developers can embed the Aptos Transfer Module into any web application and instantly
            give applications the ability to transfer assets between Aptos and other blockchains.
          </Text>
          <DancingLine></DancingLine>
          <Text variant='h3' sx={{fontSize: '14px', lineHeight: '20px'}}>
            The Widget:
          </Text>
          <Text
            variant='p2'
            sx={{mt: 2, mb: 2, maxWidth: '546px', display: 'block'}}
            color='text.secondary'
          >
            Aptos Bridge Widget is an HTML customElement. To use it, import the file like any other
            javascript file in your HTML, together with the custom styles:
          </Text>
          <SyntaxHighlighter language='html' style={vscDarkPlus} customStyle={{maxWidth: '546px'}}>
            {scriptIncludeSnippet}
          </SyntaxHighlighter>
          <Text
            variant='p2'
            sx={{mt: 2, mb: 2, maxWidth: '546px', display: 'block'}}
            color='text.secondary'
          >
            Checksum used in the integrity attribute is published in{' '}
            <Link href='https://unpkg.com/@layerzerolabs/aptos-bridge-widget@0.0.0-alpha.9/element.js.sha384'>
              <span style={{color: theme.palette.success.main}}>element.js.sha384</span>
            </Link>{' '}
            file
          </Text>
          <Text
            variant='p2'
            sx={{mt: 2.5, mb: 2, maxWidth: '546px', display: 'block'}}
            color='text.secondary'
          >
            Then use it as a regular HTML element:
          </Text>
          <SyntaxHighlighter language='html' style={vscDarkPlus}>
            {'<aptos-bridge />'}
          </SyntaxHighlighter>
          <Text
            variant='p2'
            sx={{mt: 3, maxWidth: '546px', display: 'block'}}
            color='text.secondary'
          >
            More details in the{' '}
            <Link href='https://www.npmjs.com/package/@layerzerolabs/aptos-bridge-widget'>
              <span style={{color: theme.palette.success.main}}>NPM repository</span>
            </Link>
            .
          </Text>
        </Grid>
        <DesktopOnly>
          <Grid>
            <AptosBridge />
          </Grid>
        </DesktopOnly>
        <MobileOnly sx={{width: '100%', paddingX: 2, mb: 8}}>
          <AptosBridge />
        </MobileOnly>
      </Grid>
    </Container>
  );
};

const DancingLine = () => (
  <Box mt={2.3} mb={3.5}>
    <svg
      width='546'
      height='10'
      viewBox='0 0 546 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g opacity='0.16'>
        <path
          d='M243 9H264C272.192 9 280.154 7.4 285.923 4.42857C290.077 2.31429 295.5 1 301.385 1H303'
          stroke='white'
        />
        <path d='M0 9H243' stroke='white' />
        <path d='M303 1L546 1.00002' stroke='white' />
      </g>
    </svg>
  </Box>
);
